module.exports = __webpack_public_path__ + "img/party.79c3d84e.jpg";